module.exports = __webpack_public_path__ + "8e404a08e5fd7c175e46287935b1c909.pdf";